import { ConfirmationModal, Text } from '@oy/uidesktop';
import { startCase } from 'lodash-es';
import { useTranslate } from 'src/hooks';

type ConfirmWithdrawalProps = {
  //TODO: Dashboard - check the type of receiverInfo after fix paymentInfo type
  receiverInfo?: any;
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const ConfirmWithdrawalModal = ({
  receiverInfo,
  show,
  onClose,
  onSubmit,
}: ConfirmWithdrawalProps) => {
  const { getTranslation } = useTranslate();

  return (
    <ConfirmationModal
      onPrimaryButtonClick={onSubmit}
      primaryButtonName={getTranslation('common_submit')}
      secondaryButtonName={getTranslation('common_back')}
      show={show}
      title={getTranslation('withdrawal_confirmation_title')}
      onSecondaryButtonClick={onClose}
    >
      <Text textStyle={Text.Style.BodyLgRegular}>
        {getTranslation('withdrawal_confirmation_description')}
        <br />
        <b>
          {`${receiverInfo?.bank.label} - ${receiverInfo?.receivingAccount}`}
          <br />
          {startCase(receiverInfo?.receivingAccountName.toLowerCase())}
        </b>
      </Text>
    </ConfirmationModal>
  );
};
